import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Fee } from "../utils/types/dockageFee";

export const fetchDockageFeeList = async () => {
  const response = await axiosServices.get("/dockagefee");
  const resData = await response.data;
  return convertToCamelCase<Fee[]>(resData.data);
};

export const updateDockageFeeListData = async (
  id: string,
  data: {
    [key: string]: any;
    dockageFeeId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/dockagefee/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deleteDockageFeeListData = async (id: string) => {
  const response = await axiosServices.delete(`/dockagefee/${id}`);
  return { success: response.data.success, id };
};

export const addDockageFeeListData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/dockagefee`, inputData);
  return convertToCamelCase<Fee>(response.data.data);
};
